<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

<p-dialog
  [header]="dialogHeader"
  [(visible)]="showForm"
  [breakpoints]="{ '960px': '75vw' }"
  [style]="{ width: '90vw', height: '85vh', top: '1.5rem' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  (onHide)="closeDialog()"
  [maximizable]="true"
>
  <div class="card" [formGroup]="validateForm">
    <div class="flex flex-column gap-3">
      
      <!-- Tipo de Competencia -->
      <div class="field">
        <label for="type">Tipo de Competencia</label>
        <p-selectButton
          [options]="competitionTypes"
          formControlName="type"
          optionLabel="label"
          optionValue="value"
          class="w-full"
        ></p-selectButton>
      </div>

      <!-- Nombre -->
      <div class="field">
        <label for="name">Nombre de la Competencia</label>
        <input
          type="text"
          pInputText
          placeholder="Ingrese nombre de la competencia"
          formControlName="name"
          class="w-full"
        />
      </div>

      <div class="grid">
        <!-- Fecha Inicio -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="startDate">Fecha Inicio</label>
            <input
              type="date"
              pInputText
              placeholder="Fecha de inicio"
              formControlName="startDate"
              class="w-full"
            />
          </div>
        </div>

        <!-- Fecha Fin -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="endDate">Fecha Fin</label>
            <input
              type="date"
              pInputText
              placeholder="Fecha de fin"
              formControlName="endDate"
              class="w-full"
            />
          </div>
        </div>
      </div>

      <!-- Ubicación -->
      <div class="field">
        <label for="location">Ubicación</label>
        <input
          type="text"
          pInputText
          placeholder="Ingrese la ubicación"
          formControlName="location"
          class="w-full"
        />
      </div>

      <!-- Fecha Base para Calcular Edad -->
      <div class="field">
        <label for="baseDateToCalculateAge">Fecha Base para Calcular Edad</label>
        <input
          type="date"
          pInputText
          placeholder="Fecha base para calcular edad"
          formControlName="baseDateToCalculateAge"
          class="w-full"
        />
      </div>

      <!-- Selección de Niveles -->
      <div class="field">
        <label for="levels">Niveles</label>
        <p-multiSelect
          [options]="artisticoLevels"
          formControlName="levels"
          optionLabel="name"
          placeholder="Seleccione los niveles"
          class="w-full"
          [showToggleAll]="true"
        ></p-multiSelect>
      </div>

      <!-- Selección de Categorías -->
      <div class="field">
        <label for="categories">Categorías</label>
        <p-multiSelect
          [options]="filteredCategories"
          formControlName="categories"
          optionLabel="name"
          placeholder="Seleccione las categorías"
          class="w-full"
          [showToggleAll]="true"
        ></p-multiSelect>
      </div>

      <!-- Creación de Modalidades -->
      <div class="field" *ngIf="!isUpdateForm">
        <div class="flex justify-content-between align-items-center mb-3">
          <label>Modalidades a Crear</label>
          <p-button
            label="Agregar Modalidad"
            icon="pi pi-plus"
            (onClick)="addEvent()"
            [outlined]="true"
            size="small"
          ></p-button>
        </div>
        
        <div formArrayName="eventsToCreate" *ngIf="eventsToCreate.length > 0">
          <div 
            *ngFor="let eventControl of eventsToCreate.controls; let i = index" 
            [formGroupName]="i"
            class="p-3 border-1 border-300 border-round mb-3"
          >
            <div class="grid">
              <div class="col-12 md:col-5">
                <div class="field">
                  <label [for]="'eventName' + i">Nombre de la Modalidad *</label>
                  <input
                    [id]="'eventName' + i"
                    type="text"
                    pInputText
                    formControlName="name"
                    placeholder="Nombre de la modalidad"
                    class="w-full"
                  />
                </div>
              </div>
              <div class="col-12 md:col-5">
                <div class="field">
                  <label [for]="'eventDescription' + i">Descripción</label>
                  <input
                    [id]="'eventDescription' + i"
                    type="text"
                    pInputText
                    formControlName="description"
                    placeholder="Descripción de la modalidad"
                    class="w-full"
                  />
                </div>
              </div>
              <div class="col-12 md:col-2">
                <div class="field">
                  <label>&nbsp;</label>
                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    [outlined]="true"
                    size="small"
                    (onClick)="removeEvent(i)"
                    class="w-full"
                  ></p-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="eventsToCreate.length === 0" class="text-center p-4 border-1 border-300 border-round">
          <p class="text-500 m-0">No hay modalidades agregadas. Haga clic en "Agregar Modalidad" para crear una.</p>
        </div>
      </div>

      <!-- Edición de Modalidades (Solo para edición) -->
      <div class="field" *ngIf="isUpdateForm">
        <div class="flex justify-content-between align-items-center mb-3">
          <label>Modalidades en el Evento</label>
          <p-button
            label="Agregar Nueva Modalidad"
            icon="pi pi-plus"
            (onClick)="addEvent()"
            [outlined]="true"
            size="small"
          ></p-button>
        </div>
        
        <div formArrayName="eventsToEdit" *ngIf="eventsToEdit.length > 0">
          <div 
            *ngFor="let eventControl of eventsToEdit.controls; let i = index" 
            [formGroupName]="i"
            class="p-3 border-1 border-300 border-round mb-3"
          >
            <div class="grid">
              <div class="col-12 md:col-5">
                <div class="field">
                  <label [for]="'editEventName' + i">Nombre de la Modalidad *</label>
                  <input
                    [id]="'editEventName' + i"
                    type="text"
                    pInputText
                    formControlName="name"
                    placeholder="Nombre de la modalidad"
                    class="w-full"
                  />
                </div>
              </div>
              <div class="col-12 md:col-5">
                <div class="field">
                  <label [for]="'editEventDescription' + i">Descripción</label>
                  <input
                    [id]="'editEventDescription' + i"
                    type="text"
                    pInputText
                    formControlName="description"
                    placeholder="Descripción de la modalidad"
                    class="w-full"
                  />
                </div>
              </div>
              <div class="col-12 md:col-2">
                <div class="field">
                  <label>&nbsp;</label>
                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    [outlined]="true"
                    size="small"
                    (onClick)="removeEvent(i)"
                    class="w-full"
                  ></p-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="eventsToEdit.length === 0" class="text-center p-4 border-1 border-300 border-round">
          <p class="text-500 m-0">No hay modalidades para editar. Haga clic en "Agregar Nueva Modalidad" para crear una.</p>
        </div>
      </div>

      <!-- Fechas de Inscripción -->
      <div class="grid">
        <div class="col-12 md:col-6">
          <h4>Inscripción Ordinaria</h4>
          <div class="grid">
            <div class="col-12 md:col-6">
              <div class="field">
                <label for="ordinaryStartDate">Fecha Inicio</label>
                <input
                  type="date"
                  pInputText
                  formControlName="ordinaryStartDate"
                  class="w-full"
                />
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div class="field">
                <label for="ordinaryEndDate">Fecha Fin</label>
                <input
                  type="date"
                  pInputText
                  formControlName="ordinaryEndDate"
                  class="w-full"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6">
          <h4>Inscripción Extraordinaria</h4>
          <div class="grid">
            <div class="col-12 md:col-6">
              <div class="field">
                <label for="extraordinaryStartDate">Fecha Inicio</label>
                <input
                  type="date"
                  pInputText
                  formControlName="extraordinaryStartDate"
                  class="w-full"
                />
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div class="field">
                <label for="extraordinaryEndDate">Fecha Fin</label>
                <input
                  type="date"
                  pInputText
                  formControlName="extraordinaryEndDate"
                  class="w-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tarifas por Cantidad de Eventos -->
      <div class="grid">
        <div class="col-12 md:col-6">
          <h4>Tarifas Ordinarias por Cantidad de Eventos</h4>
          <div class="mb-3">
            <p-button
              label="Agregar Tarifa"
              icon="pi pi-plus"
              (onClick)="addEventAmount('ordinary')"
              [outlined]="true"
              size="small"
            ></p-button>
          </div>
          <p-table [value]="ordinaryAthleteAmounts.controls" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th>Cantidad de Eventos</th>
                <th>Precio</th>
                <th>Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-control let-i="rowIndex">
              <tr [formGroup]="control">
                <td>
                  <p-inputNumber
                    formControlName="quantity"
                    [min]="1"
                    [showButtons]="true"
                    buttonLayout="horizontal"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus"
                  ></p-inputNumber>
                </td>
                <td>
                  <p-inputNumber
                    formControlName="amount"
                    mode="currency"
                    currency="COP"
                    locale="es-CO"
                    [min]="0"
                  ></p-inputNumber>
                </td>
                <td>
                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    [outlined]="true"
                    size="small"
                    (onClick)="removeEventAmount('ordinary', i)"
                    [disabled]="ordinaryAthleteAmounts.length <= 1"
                  ></p-button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="col-12 md:col-6">
          <h4>Tarifas Extraordinarias por Cantidad de Eventos</h4>
          <div class="mb-3">
            <p-button
              label="Agregar Tarifa"
              icon="pi pi-plus"
              (onClick)="addEventAmount('extraordinary')"
              [outlined]="true"
              size="small"
            ></p-button>
          </div>
          <p-table [value]="extraordinaryAthleteAmounts.controls" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th>Cantidad de Eventos</th>
                <th>Precio</th>
                <th>Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-control let-i="rowIndex">
              <tr [formGroup]="control">
                <td>
                  <p-inputNumber
                    formControlName="quantity"
                    [min]="1"
                    [showButtons]="true"
                    buttonLayout="horizontal"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus"
                  ></p-inputNumber>
                </td>
                <td>
                  <p-inputNumber
                    formControlName="amount"
                    mode="currency"
                    currency="COP"
                    locale="es-CO"
                    [min]="0"
                  ></p-inputNumber>
                </td>
                <td>
                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    [outlined]="true"
                    size="small"
                    (onClick)="removeEventAmount('extraordinary', i)"
                    [disabled]="extraordinaryAthleteAmounts.length <= 1"
                  ></p-button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <!-- Tarifas de Club -->
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="ordinaryClubAmount">Tarifa Club Ordinaria</label>
            <p-inputNumber
              formControlName="ordinaryClubAmount"
              mode="currency"
              currency="COP"
              locale="es-CO"
              [min]="0"
              class="w-full"
            ></p-inputNumber>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="extraordinaryClubAmount">Tarifa Club Extraordinaria</label>
            <p-inputNumber
              formControlName="extraordinaryClubAmount"
              mode="currency"
              currency="COP"
              locale="es-CO"
              [min]="0"
              class="w-full"
            ></p-inputNumber>
          </div>
        </div>
      </div>

      <!-- URLs -->
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="urlResolution">URL Resolución</label>
            <input
              type="url"
              pInputText
              placeholder="URL de la resolución"
              formControlName="urlResolution"
              class="w-full"
            />
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="urlImage">URL Imagen</label>
            <input
              type="url"
              pInputText
              placeholder="URL de la imagen"
              formControlName="urlImage"
              class="w-full"
            />
          </div>
        </div>
      </div>

      <!-- Venta Cruzada -->
      <div class="grid">
        <div class="col-12">
          <div class="field">
            <label for="hasCrosselling">Tiene Venta Cruzada</label>
            <p-selectButton
              [options]="stateOptions"
              formControlName="hasCrosselling"
              optionLabel="label"
              optionValue="value"
              class="w-full"
            ></p-selectButton>
          </div>
        </div>
      </div>

      <!-- Sección de Items de Venta Cruzada -->
      <div *ngIf="validateForm.get('hasCrosselling')?.value" class="mt-3">
        <div class="flex justify-content-between align-items-center mb-2">
          <label class="font-semibold">Items de Venta Cruzada</label>
          <p-button
            label="Agregar Item"
            icon="pi pi-plus"
            size="small"
            (click)="addCrosselingItem()"
          ></p-button>
        </div>

        <p-table
          [value]="crosselingItems"
          [tableStyle]="{'min-width': '50rem'}"
          *ngIf="crosselingItems.length > 0; else noCrosselingItems">
          <ng-template pTemplate="header">
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Precio</th>
              <th>Acciones</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.amount | currency:'COP':'symbol':'1.0-0' }}</td>
              <td>
                <p-button icon="pi pi-pencil" size="small" class="mr-2" (click)="editCrosselingItem(item, i)"></p-button>
                <p-button icon="pi pi-trash" severity="danger" size="small" (click)="deleteCrosselingItem(i)"></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <ng-template #noCrosselingItems>
          <p class="text-center text-gray-500 py-3">No hay items de venta cruzada configurados</p>
        </ng-template>
      </div>

      <!-- Configuraciones -->
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="isOpenToRegister">Abierto a Registro</label>
            <p-selectButton
              [options]="stateOptions"
              formControlName="isOpenToRegister"
              optionLabel="label"
              optionValue="value"
              class="w-full"
            ></p-selectButton>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="isPublished">Publicado</label>
            <p-selectButton
              [options]="stateOptions"
              formControlName="isPublished"
              optionLabel="label"
              optionValue="value"
              class="w-full"
            ></p-selectButton>
          </div>
        </div>
      </div>

      <!-- Configuración de Pagos -->
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="digitalPaymentAvailable">Pago Digital Disponible</label>
            <p-selectButton
              [options]="stateOptions"
              formControlName="digitalPaymentAvailable"
              optionLabel="label"
              optionValue="value"
              class="w-full"
            ></p-selectButton>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="manualPaymentAvailable">Pago Manual Disponible</label>
            <p-selectButton
              [options]="stateOptions"
              formControlName="manualPaymentAvailable"
              optionLabel="label"
              optionValue="value"
              class="w-full"
            ></p-selectButton>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Cancelar"
        severity="secondary"
        [outlined]="true"
        (onClick)="closeDialog()"
      ></p-button>
      <p-button
        [label]="isUpdateForm ? 'Actualizar' : 'Crear'"
        severity="primary"
        (onClick)="isUpdateForm ? updateCompetition() : saveCompetition()"
        [disabled]="!validateForm.valid"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Diálogo para Item de Venta Cruzada -->
<p-dialog
  [header]="editingIndex === -1 ? 'Nuevo Item de Venta Cruzada' : 'Editar Item de Venta Cruzada'"
  [(visible)]="showCrosselingDialog"
  [style]="{ width: '50vw' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeCrosselingDialog()"
>
  <div class="flex flex-column gap-3" *ngIf="editingCrosselingItem">
    <div class="flex flex-column gap-2">
      <label>Nombre *</label>
      <input
        type="text"
        pInputText
        placeholder="Nombre del item"
        [(ngModel)]="editingCrosselingItem.name"
      />
    </div>

    <div class="flex flex-column gap-2">
      <label>Descripción *</label>
      <textarea
        pInputTextarea
        rows="3"
        placeholder="Descripción del item"
        [(ngModel)]="editingCrosselingItem.description"
      ></textarea>
    </div>

    <div class="flex flex-column gap-2">
      <label>Precio *</label>
      <p-inputNumber
        [(ngModel)]="editingCrosselingItem.amount"
        mode="currency"
        currency="COP"
        locale="es-CO"
        [min]="0"
        placeholder="Precio del item"
      ></p-inputNumber>
    </div>

    <div class="flex flex-column gap-2">
      <label>URL Imagen</label>
      <input
        type="text"
        pInputText
        placeholder="URL de la imagen del item"
        [(ngModel)]="editingCrosselingItem.urlImage"
      />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex gap-2 justify-content-end">
      <p-button
        label="Cancelar"
        [outlined]="true"
        severity="secondary"
        (click)="closeCrosselingDialog()"
      ></p-button>
      <p-button
        label="Guardar"
        [disabled]="!editingCrosselingItem?.name || !editingCrosselingItem?.description || !editingCrosselingItem?.amount"
        (click)="saveCrosselingItem()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>